import { useContext } from 'react';
import { MovexBuilderRouteTransitionContext } from '@/contexts/movexBuilderRouteTransition/context.js';

const useMovexBuilderRouteTransition = () => {
  return useContext(MovexBuilderRouteTransitionContext);
};

export default useMovexBuilderRouteTransition;
